export var emailValidationRules = function emailValidationRules(_ref) {
  var message = _ref.message;
  return {
    required: true,
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: message
    }
  };
};